// @flow
import { fork, all } from 'redux-saga/effects';
import { saga as contractsSaga } from './Contracts';

export default function*(): Generator<*, *, *> {
  yield all([fork(contractsSaga)]);
}
